// Motion primitives — single source of truth for easings, durations,
// and shared variants so the editorial pacing stays consistent.
// Phase 7: escalated durations for image-led institutional feel.

export const EASE = [0.22, 1, 0.36, 1];

export const DURATIONS = {
  pageOut: 0.4,
  pageIn: 0.9,
  reveal: 0.9,
  revealImage: 1.4,
  heroLine: 0.7,
  heroLineStagger: 0.12,
  heroScaleIn: 1.8,
  ruleDraw: 0.9,
  anchorScaleIn: 1.4,
  hover: 0.3,
};

export const prefersReducedMotion = () => {
  if (typeof window === "undefined") return false;
  if (!window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

// Common variants
export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATIONS.reveal, ease: EASE },
  },
};

export const heroLineVariant = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: DURATIONS.heroLine, ease: EASE, delay: 0.2 + i * DURATIONS.heroLineStagger },
  }),
};
